export enum MutationDirective {
  PUT = 'pdbPut',
  POST = 'pdbPost',
  BULK_DOCS = 'pdbBulkDocs'
}
